// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"login_loginWrapper__3XStS","form":"login_form__1hy51","userAvatar":"login_userAvatar__3qse0"};